module.exports = __webpack_public_path__ + "static/media/door1.5124a443.png";